import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import { TokenService } from '@/services/storage.service';
import ApiService from '@/services/api.service';
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { ValidationProvider,ValidationObserver } from 'vee-validate/dist/vee-validate.full';
import Vuelidate from 'vuelidate'
import moment from 'moment'
import VoerroTagsInput from '@voerro/vue-tagsinput';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import excel from 'vue-excel-export';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";


Vue.config.productionTip = false;

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueFormWizard)
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.use(Vuelidate);
Vue.component('tags-input', VoerroTagsInput);
Vue.use(datePicker);
Vue.use(excel);
Vue.component('v-select', vSelect);

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM-DD-YYYY')
  }
});

Vue.filter('twoDecimal', function(value) {
  if (value != '') {    
    return '(' + parseFloat(value).toFixed(2)+')';
  }
});

Vue.mixin({
  data: function() {
    return {
            pageOptions: [{
                text: '10', value: '10',
            }, {
                text: '50', value: '50'
            }, {
                text: '100', value: '100',
            }, {
                text: '250', value: '250',
            }, {
                text: '500', value: '500',
            }],
        }
  }
})

Vue.filter('uppercase', function(value) {
 if (!value) {
  return '';
}
value = value.toString();
value = value.replace(/[#_]/g,' ');

return value.toLowerCase().split(' ').map(function(word) {
  return word.replace(word[0], word[0].toUpperCase());
}).join(' ');

});

ApiService.init(process.env.VUE_APP_BASE_URL)

// If token exists set header
if (TokenService.getToken()) {  ApiService.setHeader() }

  new Vue({
    render: h => h(App),
    router,
    store
  }).$mount("#app");
